export default [
  {
    path: '/print-queue-dashboard',
    name: 'print-queue-dashboard',
    component: () => import('@/views/DashboardPrintQueueUser.vue'),
    meta: {
      protected: true,
      clinicianBlocked: true,
      pageTitle: 'Post Search',
      breadcrumb: [
        {
          text: 'Post Search',
          active: true,
        },
      ],
    },
  },
  {
    path: '/print-queue-printed',
    name: 'print-queue-printed',
    component: () => import('@/views/postSearch/PostSearchLimitedPrintQueueUser.vue'),
    meta: {
      protected: true,
      clinicianBlocked: true,
      pageTitle: 'Post Search',
      breadcrumb: [
        {
          text: 'Post Search',
          active: true,
        },
      ],
    },
  },
]
